<template>
	<div>
		<template v-if="refIndex === 0"> [[Circular reference]] (root) </template>
		<ConsoleEventArg v-else renderAs="ArgValue" :serialized="serialized" :value="referenced" />
	</div>
</template>

<script>
export default {
	name: 'ArgRef',
	props: {
		serialized: Object,
		value: {
			type: Object,
			required: true,
		},
	},
	computed: {
		refIndex() {
			return this.value['@r']
		},
		referenced() {
			return this.serialized.serialized[this.value['@r']]
		},
	},
}
</script>
